/**
 * Chatbot response helpers
 * Updated to match Ultimate Resume - Full-Stack Software Engineer
 */

export const getWelcomeMessage = () => {
  const messages = [
    "Hi! I'm Harish Yerraguntla 👋\n\nI'm a full-stack software engineer specializing in React, Vue, TypeScript, and Node.js. I can answer questions about my work experience, technical skills, projects, and more.\n\nWhat would you like to know?",
    "Hey there! 👋 I'm Harish Yerraguntla.\n\nAsk me anything about my:\n• Full-stack development expertise (React, Vue, Node.js, Python)\n• Work experience & real-time data visualization projects\n• Technical skills & performance optimization\n• Education & contact info",
    "Hello! Welcome to my portfolio.\n\nI'm Harish Yerraguntla, a full-stack software engineer with 5+ years of experience building scalable applications with React, Vue, TypeScript, and modern backend technologies.\n\nWhat interests you?",
  ];

  return messages[Math.floor(Math.random() * messages.length)];
};

export const getSuggestions = () => {
  return [
    "What's your tech stack?",
    "Tell me about your experience",
    "What projects have you built?",
    "How can I contact you?",
  ];
};

export const getErrorMessage = () => {
  return "Oops! Something went wrong. Please try asking your question again.";
};

export const getNoMatchMessage = () => {
  return "I'm not sure I understand that question. I can help you learn about my:\n\n• Full-stack development (React, Vue, Node.js, Python)\n• Work experience and achievements\n• Real-time data visualization projects\n• Performance optimization & modern tooling\n• Education background & contact information\n\nWhat would you like to know?";
};

export const getTypingMessages = () => {
  return [
    "Let me think...",
    "Just a moment...",
    "Looking that up...",
    "Hmm, interesting question...",
  ];
};

export const getRandomTypingMessage = () => {
  const messages = getTypingMessages();
  return messages[Math.floor(Math.random() * messages.length)];
};
